module.exports = __webpack_public_path__ + "static/media/Dog_kiss.2121943b.jpg";